import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  private titleService = inject(Title);

  private isFocused = true;
  private appTitle = 'Help me Fix';
  private faviconElement: HTMLLinkElement = document.querySelector('#favicon');
  private faviconHref = 'favicon.ico';

  constructor() {
    window.addEventListener('blur', this.checkBlurTab.bind(this));
    window.addEventListener('focus', this.checkFocusTab.bind(this));
    window.addEventListener('resize', this.resizeHandler.bind(this));
  }

  resizeHandler(_: Event): void {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  changeTitle(title = 'You have new message!'): void {
    if (this.isFocused) return;
    this.titleService.setTitle(title);
    this.faviconElement.href = '/assets/notification-favicon.png';
  }

  checkBlurTab(_event: unknown): void {
    this.isFocused = false;
  }

  checkFocusTab(_event: unknown): void {
    this.changeTitle(this.appTitle);
    this.faviconElement.href = this.faviconHref;
    this.isFocused = true;
  }
}
